export const fieldErrorMessages = {
  companyDomain:
    'Ensure the domain is in a valid format (e.g., subdomain.example.com).',
  companyName: 'Company name cannot exceed 50 characters.',
  primaryColor: 'Invalid primary color format.',
  notifBgColor: 'Invalid notification background color format.',
};

export const fileSize = {
  headerLogo: 33,
  loginLogo: 24,
  favicon: 16,
  loaderLogo: 70,
};
